import { Track } from "../../types";

import DocumentCategoryCard from "./documents-list/document-category-card";
import useTrackDocuments from "../../hooks/use-track-documents.hook";

export default function MaterialDocuments({
  track,
}: Readonly<{ track: Track }>) {
  const { data } = useTrackDocuments({
    trackId: track.uid,
  });
  return (
    <DocumentCategoryCard
      documentType="MaterialSelection"
      documents={
        data?.filter((doc) => doc.documentType === "MaterialSelection") || []
      }
    />
  );
}
